export const getToken = () => localStorage.getItem('token');

export const setToken = (token) => localStorage.setItem('token', token);

export const removeToken = () => localStorage.removeItem('token');

export const getUser = () => {
  const user = localStorage.getItem('user');
  try {
    return user ? JSON.parse(user) : null;
  } catch {
    return null;
  }
};

export const setUser = (user) => localStorage.setItem('user', JSON.stringify(user));

export const removeUser = () => localStorage.removeItem('user');

// Parse JWT to check expiration
const parseJwt = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
};

// Vérifie si le token est valide et non expiré
// Avec marge de sécurité de 30 secondes pour éviter les race conditions
export const isAuthenticated = () => {
  const token = getToken();
  if (!token) return false;
  
  // Check if token is expired
  const payload = parseJwt(token);
  if (!payload || !payload.exp) {
    // Token invalide - nettoyage silencieux
    removeToken();
    removeUser();
    return false;
  }
  
  // Marge de sécurité de 30 secondes
  const now = (Date.now() / 1000) + 30;
  if (payload.exp < now) {
    // Token expiré ou sur le point d'expirer - nettoyage
    removeToken();
    removeUser();
    sessionStorage.removeItem('hasSeenSplash');
    return false;
  }
  
  return true;
};

// Retourne le temps restant avant expiration (en secondes)
export const getTokenTimeRemaining = () => {
  const token = getToken();
  if (!token) return 0;
  
  const payload = parseJwt(token);
  if (!payload || !payload.exp) return 0;
  
  const now = Date.now() / 1000;
  return Math.max(0, Math.floor(payload.exp - now));
};

// Vérifie si le token expire dans moins de X minutes
export const isTokenExpiringSoon = (minutesThreshold = 60) => {
  const remaining = getTokenTimeRemaining();
  return remaining > 0 && remaining < (minutesThreshold * 60);
};

export const isAdmin = () => {
  const user = getUser();
  return user?.role === 'ADMIN' || user?.role === 'SUPER_ADMIN';
};

export const isSuperAdmin = () => {
  const user = getUser();
  return user?.role === 'SUPER_ADMIN';
};

export const isConcoursStudent = () => {
  const user = getUser();
  return user?.role === 'CONCOURS_STUDENT';
};

export const isEducatorDemo = () => {
  const user = getUser();
  return user?.role === 'EDUCATOR_DEMO';
};

export const logout = () => {
  removeToken();
  removeUser();
  sessionStorage.removeItem('hasSeenSplash');
  window.location.replace('/login');
};
